import { __assign, __rest } from "tslib";
import React, { useState, useCallback } from 'react';
import { st, classes } from './MessageModalLayout.st.css';
import BaseModalLayout from '../BaseModalLayout';
import PropTypes from 'prop-types';
import Button from '../Button';
/** MessageModalLayout */
var MessageModalLayout = function (_a) {
    var children = _a.children, className = _a.className, restProps = __rest(_a, ["children", "className"]);
    var illustration = restProps.illustration;
    var _b = useState(false), showFooterDivider = _b[0], setShowFooterDivider = _b[1];
    var onContentScrollAreaChanged = useCallback(function (_a) {
        var area = _a.area;
        var scrollArea = area.y;
        var newShowDivider = scrollArea === 'top' || scrollArea === 'middle';
        setShowFooterDivider(newShowDivider);
    }, []);
    var hasIllustration = !!illustration;
    return (React.createElement(BaseModalLayout, __assign({}, restProps, { className: st(classes.root, { hasIllustration: hasIllustration }, className) }),
        React.createElement("div", { className: classes.topAreaContainer },
            React.createElement(BaseModalLayout.Illustration, null),
            React.createElement("div", { className: classes.contentAreaContainer },
                React.createElement(BaseModalLayout.Header, null),
                React.createElement(BaseModalLayout.Content, { hideTopScrollDivider: hasIllustration, hideBottomScrollDivider: hasIllustration, scrollProps: {
                        onScrollAreaChanged: (hasIllustration && onContentScrollAreaChanged) || null,
                    } }, children))),
        React.createElement(BaseModalLayout.Footer, { showFooterDivider: hasIllustration && showFooterDivider }),
        React.createElement(BaseModalLayout.Footnote, null)));
};
MessageModalLayout.displayName = 'MessageModalLayout';
MessageModalLayout.propTypes = {
    /** ...BaseModalLayout.propTypes, */
    /** additional css classes */
    className: PropTypes.string,
    /** data hook for testing */
    dataHook: PropTypes.string,
    /** callback for when the close button is clicked */
    onCloseButtonClick: PropTypes.func,
    /** callback for when the help button is clicked */
    onHelpButtonClick: PropTypes.func,
    /** a global theme for the modal, will be applied as stylable state and will affect footer buttons skin */
    theme: PropTypes.oneOf(['standard', 'premium', 'destructive']),
    /** ...Header.propTypes, */
    /** The modal's title */
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    /** ...Content.propTypes, */
    /** the content you want to render in the modal, children passed directly will be treated as `content` as well */
    content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    /** ...Footer.propTypes, */
    /** will determine the action buttons size*/
    actionsSize: Button.propTypes.size,
    /** a text for the primary action button */
    primaryButtonText: PropTypes.string,
    /** a callback for when the primary action button is clicked */
    primaryButtonOnClick: PropTypes.func,
    /** Passed to the primary action button as props without any filter / mutation */
    primaryButtonProps: (function () {
        var _a = Button.propTypes, dataHook = _a.dataHook, buttonProps = __rest(_a, ["dataHook"]);
        return PropTypes.shape(buttonProps);
    })(),
    /** a text for the secondary action button */
    secondaryButtonText: PropTypes.string,
    /** callback for when the secondary action button is clicked */
    secondaryButtonOnClick: PropTypes.func,
    /** Passed to the secondary button as props without any filter / mutation */
    secondaryButtonProps: (function () {
        var _a = Button.propTypes, dataHook = _a.dataHook, buttonProps = __rest(_a, ["dataHook"]);
        return PropTypes.shape(buttonProps);
    })(),
    /** side actions node, to be rendered as the first element on the same row as the action buttons */
    sideActions: PropTypes.node,
    /** ...Footnote.propTypes, */
    /** a footnote node, to be rendered at the very bottom of the modal */
    footnote: PropTypes.node,
    /** ...Illustration.propTypes, */
    /** The illustration src or the illustration node itself */
    illustration: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};
MessageModalLayout.defaultProps = {
    theme: 'standard',
    actionsSize: 'small',
};
export default MessageModalLayout;
//# sourceMappingURL=MessageModalLayout.js.map